import React from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';

interface EChartsWrapperProps {
  option: EChartsOption;
  height?: number | string;
  className?: string;
  loading?: boolean;
}

export const EChartsWrapper: React.FC<EChartsWrapperProps> = ({
  option,
  height = 400,
  className = '',
  loading = false
}) => {
  return (
    <div className={`w-full ${className}`}>
      <ReactECharts
        option={option}
        style={{ height }}
        showLoading={loading}
        theme="light"
        opts={{ renderer: 'canvas' }}
      />
    </div>
  );
};
